import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Events from './pages/Events';
import EventDetail from './pages/EventDetail';
import Login from './pages/Login';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Musikk from './pages/Musikk';
import Nyheter from './pages/Nyheter';
import NewsArticlePage from './pages/NewsArticlePage';
import Profile from './pages/Profile';
import Admin from './pages/Admin';
import DevTools from './components/DevTools';
import ScrollToTop from './components/ScrollToTop';
import { EnvProvider } from './contexts/EnvContext';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

// Main content component wrapped with EnvProvider
const AppContent: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-black flex flex-col">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/events" element={<Events />} />
            <Route path="/events/:slug" element={<EventDetail />} />
            <Route path="/login" element={<Login />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<BlogPost />} />
            <Route path="/musikk" element={<Musikk />} />
            <Route path="/nyheter" element={<Nyheter />} />
            <Route path="/nyheter/:id" element={<NewsArticlePage />} />
            <Route path="/news" element={<Navigate to="/blog" replace />} />
            <Route
              path="/account"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/users/:username"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute requiredRole="admin">
                  <Admin />
                </ProtectedRoute>
              }
            />
          </Routes>
        </main>
        <Footer />
        
        {/* DevTools for toggling between modes */}
        <DevTools />
      </div>
    </Router>
  );
};

// App root component that provides the environment and auth contexts
function App() {
  return (
    <EnvProvider>
      <AuthProvider>
        <div className="overflow-x-hidden">
          <AppContent />
        </div>
      </AuthProvider>
    </EnvProvider>
  );
}

export default App;
